export { default as VictoryPie } from "./victory-pie";
export { default as Slice } from "./slice";


//////////////////
// WEBPACK FOOTER
// ./~/victory-pie/es/index.js
// module id = ./node_modules/victory-pie/es/index.js
// module chunks = 1